import { render, staticRenderFns } from "./GatewayImage.vue?vue&type=template&id=9b8d6400&"
import script from "./GatewayImage.vue?vue&type=script&lang=js&"
export * from "./GatewayImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports